import styled from 'styled-components';
import { Common, color } from '@stockbit/ui';

const { Input: BaseInput } = Common;

export const Divider = styled.div`
  border-top: solid 1px ${color.gainsboro};
  height: 1px;
  margin: 10px 0;
`;

export const Input = styled(BaseInput)`
  .ant-input-suffix {
    color: rgb(203, 203, 203);
  }

  input::placeholder {
    color: ${color.highgray};
    font-size: 15px !important;
    font-family: var(--bold-font);
    opacity: 0.3;
  }
`;
